<template>
  <Card class="i-content" :bordered="false" dis-hover>
    <div class="demo-split">
      <!-- 左边内容区 -->
      <div class="demo-split-left">
        <slot name="left" />
      </div>
      <!-- 右边内容区 -->
      <div class="demo-split-right">
        <slot name="right" />
      </div>
    </div>
  </Card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "HomeCommon",
  data: () => ({
    value1: false
  }),
  mounted() { },
  computed: {
    ...mapGetters({
      isMobile: "getIsMobile"
    })
  },
  method: {

  }
};
</script>
<style lang="postcss" scoped>
.i-content {
  min-height: calc(100vh - 174px);

  & .i-search-bar {
    display: flex;
    justify-content: space-between;
  }

  & .i-content {
    min-height: auto;

    & .ivu-card-body {
      padding: 0;
    }
  }

}

.demo-split {
  min-height: calc(100vh - 174px);
  display: flex;

  & .demo-split-left {
    flex: 1;
  }

  & .demo-split-right {
    flex: 1
  }
}
</style>
